export default {
  pageTitle: 'Ad Account Auth',
  management: 'Account Authorization Management',
  point: {
    management: 'PL Tracking Management',
  },
  authRange: {
    router: {
      confirm: {
        ok: 'Authorize',
        goPl: 'To Production',
      },
      nodata: {
        title: 'No Viewable Data',
        noplaceDesc: 'No playables currently. You can go to create.',
        desc: 'The data range for authorized accounts is set to "Not Fetch," so there is no viewable data. You can edit this on authorization management.',
      },
      noadv: {
        tooltip:
          'The platform has not authorized the advertising account. Please authorize the advertising account in "Common Settings" - "Authorization Management" to view the data.',
        title: 'No Authorized Accounts',
        desc: 'You need to authorize ad accounts before view data.',
      },
      noReport: {
        tooltip:
          'This channel does not support ad performance data, only interaction data.',
      },
      norange: {
        title: 'No Account Sets Data Range',
        desc: 'The authorized account has not set the data range. Please set it on authorization management first.',
      },
      channel: {
        nodata: {
          title: 'No Viewable Data',
          desc: 'The data range for authorized accounts on this platform is set to "Not Fetch," so there is no viewable data. You can edit this on authorization management.',
        },
      },
    },
    settingDialog: {
      title: 'Account Data Range Setting',
      desc: 'Please choose the data range for the following authorized accounts that Playturbo can fetch.',
      form: {
        col: {
          trafficType: {
            title: 'Networks',
          },
          accountName: {
            title: 'Account Name',
          },
          dataRange: {
            title: 'Data Range',
          },
        },
      },
    },
    updateDialog: {
      title: 'Data Range Setting',
    },
    settting: {
      success: 'Edit Successfully',
    },
  },
  authPage: {
    description: 'Unified Account Authorization Management',
  },
  authLabel: 'Authorize',
  authDialog: {
    quickAuth: {
      desc: 'Click to Get',
      label: 'Account Info',
      tips: "Fill in the account information for the current account's email corresponding to the Mintegtal advertising platform.",
    },
    title: 'Account Authorization',
    agreement: '"Authorization Agreement"',
    guideText: 'Operational Guidance',
    secret: 'Read and Accepted',
    form: {
      dataRange: {
        label: 'Data Range',
        part: 'Creatives created using Playturbo',
        forbidden: 'Not Fetch',
        all: 'All Creatives',
        tipsLabel:
          'Timezone: Follows the timezone of the main account under this network.Update time: Data for the previous day will be updated at 02:00 in the corresponding timezone.',
      },
    },
  },
  table: {
    pushAccountName: 'Account for Application',
    action: {
      pushInfo: 'Creative Info',
      manage: 'Sub-account management',
      bind: 'Authorize',
      unbind: 'Cancel Authorization',
      delete: 'Delete',
      assistAccount: 'Assist Account Management',
    },
    column: {
      assist: 'Assist',
      email: 'Email',
      account: 'Account',
      status: 'Status',
      action: 'Operations',
    },
    account: {
      sign: {
        main: 'Main Account',
        sub: 'Sub-account',
      },
    },
    pushId: 'Application ID',
    pushChannel: 'Apply to',
    search: {
      email: 'Email',
      accountName: 'Account Name',
      status: 'Status',
      authTime: 'Authorization Time',
    },
  },
  accountDialog: {
    table: {
      column: {
        accountName: 'Account Name',
        traffic_type: 'Platform',
        authTime: 'Authorization time',
      },
    },
    info: {
      channel: 'Platform',
      email: 'Main Account Email',
      accountName: 'Main Account Name',
    },
    title: 'Sub-account management',
  },
  pushInfoDialog: {
    table: {
      column: {
        pushdownload: 'Download / Application Status',
        id: 'Creative ID',
        name: 'Creative Name',
      },
    },
  },
  bindtips: {
    title: 'Reauthorize',
    content: 'Are you sure to re-authorize {name} on {channel} platform?',
    confirm: 'Authorize',
  },
  deletetips: {
    title: 'Are you sure to delete?',
    desc: 'Are you sure to delete {name} on {channel} platform?',
    confirm: 'Delete',
  },
  auth: {
    error: {
      tips: 'Authorization status is abnormal and can be retried by adding new authorization.',
    },
    success: {
      message: 'Authorize Successfully',
    },
    dataRange: {
      tips: 'Fetch data only for creatives generated by Playturbo.',
    },
    cancel: {
      title: 'Cancel Authorization',
      desc: 'After canceling authorization, you will not be able to push creatives to this account or fetch datas. Are you sure to cancel the authorization?',
      confirm: 'Cancel Authorization',
      cancel: 'Retain',
    },
  },
  delete: {
    success: {
      message: 'Delete Successfully',
    },
  },
  authStatus: {
    active: 'Authorized',
    unbound: 'Authorization Canceled',
    disabled: 'Authorization Failed',
    pending: 'Authorization In Progress',
    unactive: 'Unauthorized',
  },
  assistAccountDialog: {
    title: 'Assist Account Management',
    addBtn: 'Add Assist Account',
    table: {
      name: 'Account Name',
      type: 'Types',
      assistantAccount: 'Assist Account',
      action: 'Operations',
    },
    closeBtn: 'Close',
  },
  addAssistAccountDialog: {
    title: 'Add Assist Account',
    inputName: 'Playturbo Account Name',
    successMessage: 'Assist Account Added Successfully',
  },
}
